import clsx from 'clsx'
import React from 'react'
import {makeStyles} from 'external/material'
import {faArrowAltCircleRight, faTimesCircle, faCheckCircle} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import Box from '@mui/material/Box'

const useStyles = makeStyles(statusIconStyles)

export default function StatusIcon ({value, answer, correctAnswer}) {
  const classes = useStyles()

  function getStatus () {
    if (value != correctAnswer && value == answer) return 'incorrect'
    if (value == correctAnswer && value == answer) return 'correct'
    if (value == correctAnswer && value != answer) return 'mark'
    return 'dummy'
  }

  const status = getStatus()
  const icon = {
    incorrect: faTimesCircle,
    correct: faCheckCircle,
    mark: faArrowAltCircleRight,
    dummy: faTimesCircle
  }[status]

  return (<Box className={clsx(classes.root, status)}><FontAwesomeIcon icon={icon} /></Box>)
}

function statusIconStyles (theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      color: "#fff",
      marginRight: 20,
      fontSize: '20px',
      '&.dummy': {
        visibility: 'hidden'
      },
      '&.mark': {
        '& svg': {
          color: '#18d0da',
        }
      },
      '&.incorrect': {
        '& svg': {
          color: '#dd2229'
        },
      },
      '&.correct': {
        '& svg': {
          color: '#39c55a',
        },
      },
    },
  }
}
